import React from 'react'
import Link from 'next/link'
import routes from 'routes'

interface TagListProps extends React.HTMLAttributes<HTMLDivElement> {
  tags: any
}

const TagList = (props: TagListProps): JSX.Element => {
  const { tags, ...attributes } = props

  return (
    <div {...attributes}>
      {tags.length > 0 ? (
        <ul className="flex flex-wrap text-sm">
          {tags.map((tag) => (
            <li
              key={tag.id}
              className="block mr-4 mb-4 rounded-md bg-gold bg-opacity-70"
            >
              <Link
                href={routes.search.search({ keywords: tag.value })}
                title={tag.label}
                className="flex items-center px-4 py-2"
              >
                <span className="block text-goldInnerText">{tag.label}</span>
              </Link>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  )
}

export default TagList
